import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	height: 41px;
	padding: 0 20px;
	margin-top: 20px;

	${Text} {
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		font-weight: 500;
		color: #ffffff;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 435px;
	padding: 0 20px;
`;

const StyledAvatar = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 100px;
	border-radius: 100px;
	background-color: rgba(217, 217, 217, 0.1);
	margin-top: 20px;

	${Text} {
		font-weight: 500;
		font-size: 40px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledInputsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-top: 40px;

	input {
		width: 340px;
	}
`;

const StyledButtonContainer = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	padding: 0 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;

	img {
		width: 16px;
		height: 16px;
	}
`;

export {
	StyledAvatar,
	StyledButtonContainer,
	StyledButtonContent,
	StyledContainer,
	StyledHead,
	StyledInputsContainer,
};
